import { type ButtonProps } from '@jouzen/ecom-components/v3/Button';
import { cx } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

import LandingPageHeroCtaButton from './LandingPageHeroCtaButton';

export interface LandingPageHeroCtaProps extends Omit<ButtonProps, 'hidden'> {
  readonly fixed?: {
    sm: boolean;
    lg: boolean;
  };
  readonly hidden?: {
    sm: boolean;
    lg: boolean;
  };
  readonly label: MessageKey;
}

const LandingPageHeroCta = ({
  fixed = {
    sm: false,
    lg: false,
  },
  hidden = {
    sm: false,
    lg: false,
  },
  label,
  ...props
}: PropsWithChildren<LandingPageHeroCtaProps>) => {
  return (
    <div
      className={cx('w-full text-center lg:text-left', {
        'fixed bottom-8 left-0': fixed.sm,
        'lg:relative lg:bottom-auto lg:left-auto': !fixed.lg,
        'lg:fixed lg:bottom-16': fixed.lg,
        hidden: hidden.sm,
        'lg:block': !hidden.lg,
        'lg:hidden': hidden.lg,
      })}
      data-cy="landing-page-hero-cta-wrapper"
    >
      <LandingPageHeroCtaButton {...props}>
        <RichText messageKey={label} />
      </LandingPageHeroCtaButton>
    </div>
  );
};

export default LandingPageHeroCta;
